import dateFormatType from '@/constants/dateFormatType';
import { parse } from 'date-fns';
export default {
    getterBetweenDate: ({ betweenDate }) => betweenDate,
    /**
     * betweenDate를 timestamp로 변경
     * @param {Object} state
     * @returns {Array}
     */
    getterBetweenDateToTimeStamp: ({ betweenDate }) => {
        const dateObject = new Date();
        const [date1, date2,] = betweenDate;
        const dateFormat = dateFormatType.DATE;
        if (!date1 || !date2) {
            return [];
        }
        const [d1, d2,] = [
            date1,
            date2,
        ].map((it) => parse(it, dateFormat, dateObject));
        // local time -> epoch time기준으로 변경하기, 오전 12:00:00:00 ~ 오후 11:59:59:999 으로 변경
        // epoch time으로 보내면 서버에서 바로고 타임존으로 변경해줌
        return [
            d1.setHours(9, 0, 0, 0),
            d2.setHours(32, 59, 59, 999),
        ];
    },
    getterBaromoneyReportList: ({ tableItems }) => tableItems,
};
